import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useNavigate } from '@tanstack/react-router';
import { EnvelopeSimpleIcon } from '@phosphor-icons/react';
import { Card } from '../../../shared/ui';

interface CheckInboxPageProps {
  email?: string;
  reason?: 'verify' | 'magic-link';
}

export const CheckInboxPage = ({ email, reason }: CheckInboxPageProps) => {
  const navigate = useNavigate();

  const isMagicLink = reason === 'magic-link';

  const title = isMagicLink ? 'Check your inbox' : 'Verify your email';
  const body = isMagicLink
    ? `We sent a magic sign-in link to ${email ? email : 'your email'}. Click the link to sign in — it expires in 1 hour.`
    : `We sent a verification link to ${email ? email : 'your email'}. Click the link to activate your account, then sign in.`;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Card>
        <Box sx={{ textAlign: 'center', py: 2, px: 1, maxWidth: 420 }}>
          <Box sx={{ mb: 2, color: '#3d98ff' }}>
            <EnvelopeSimpleIcon size={64} weight="duotone" />
          </Box>

          <Typography variant="h5" gutterBottom fontWeight={700}>
            {title}
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {body}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Didn&apos;t receive it? Check your spam folder.
          </Typography>

          <Button
            variant="outlined"
            onClick={() => navigate({ to: '/login' })}
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Back to sign in
          </Button>
        </Box>
      </Card>
    </Box>
  );
};
